import React, { HTMLAttributes } from 'react'

import CrossMediumAlt from '@helpscout/hsds-icons/cross'
import classNames from 'classnames'

import { getValidProps } from 'hsds/utils/react'

import { ButtonCloseUI } from './ButtonClose.styles'

function noop() {}

export const SIZES = ['xs', 'sm', 'md', 'lg'] as const

type Props = {
  /** Custom class names to be added to the component. */
  className?: string
  innerRef?: React.Ref<HTMLButtonElement>
  /** Callback function when the component is blurred. */
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void
  /** onclick handler */
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement>
  ) => void | Promise<void | boolean | undefined> | boolean
  /** Callback function when the component is focused. */
  onFocus?: (event: React.FocusEvent<HTMLButtonElement>) => void
  /** Applies a seamless style to the component. */
  seamless?: boolean
  size?: (typeof SIZES)[number]
  /** Custom title for the button. */
  title?: string
  /** Data attr for Cypress tests. */
  'data-cy'?: string
} & HTMLAttributes<HTMLButtonElement>

function ButtonClose({
  'data-cy': dataCy = 'CloseButton',
  className,
  innerRef = noop,
  seamless = false,
  size,
  title = 'Close',
  onBlur = noop,
  onClick = noop,
  onFocus = noop,
  ...rest
}: Props) {
  return (
    <ButtonCloseUI
      aria-label={title || 'Close'}
      data-cy={dataCy}
      onBlur={onBlur}
      onClick={onClick}
      onFocus={onFocus}
      {...getValidProps(rest)}
      className={classNames(
        'c-CloseButton', //backwards compat
        'c-ButtonClose',
        seamless && 'is-seamless',
        className
      )}
      ref={innerRef}
      icon={CrossMediumAlt}
      size={size}
      color="white"
    />
  )
}

export default ButtonClose
